import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TitleStyles from "../../../components/ui/TitleStyles";
import Description from "../../../components/ui/Description";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import {
  Container,
  InputWrapper,
  Prefix,
  StyledInput,
  Position,
} from "./UrlStyles";
import { usePressKit } from "../../../context/PressKitContext";

const Url = () => {
  const navigate = useNavigate();
  const { pressKitData } = usePressKit(); // exemplo: pressKitData.artistName
  const artistName = pressKitData?.artistName || ""; // fallback
  const [customLink, setCustomLink] = useState("");

  // Gera sugestão automática com base no nome artístico
  useEffect(() => {
    if (artistName) {
      const suggestion = artistName.toLowerCase().replace(/\s+/g, "-");
      setCustomLink(suggestion);
    }
  }, [artistName]);

  const handleNext = () => {
    // Se o campo estiver vazio, usa o nome artístico como sugestão
    const finalValue = customLink.trim()
      ? customLink.trim()
      : artistName.toLowerCase().replace(/\s+/g, "-");

    const finalUrl = `https://www.presskit.link.dj-${finalValue}`;
    console.log("Link final:", finalUrl);

    // Aqui no futuro: verificar se já existe no banco
    navigate("/preview");
  };

  return (
    <Container>
      <TitleStyles>Personalize seu Link</TitleStyles>
      <Description>Escolha um link de URL personalizado</Description>

      <InputWrapper>
        <Prefix>https://www.presskit.link.dj-</Prefix>
        <StyledInput
          type="text"
          placeholder="seu-nome"
          value={customLink}
          onChange={(e) => setCustomLink(e.target.value)}
        />
      </InputWrapper>

      <Position>
        <ButtonGroup
          onBack={() => navigate("/edit")}
          onNext={handleNext}
          nextLabel="Finalizar >"
        />
      </Position>
    </Container>
  );
};

export default Url;
